import { createSelector } from 'reselect';
import { prop } from 'ramda';

export const getRecaptcha = prop('recaptcha');

export const getCaptchaV2Token = createSelector(getRecaptcha, prop('v2Token'));
